import type { PublicSong, SiteSettings } from "./types";

export function normalizeSearch(value: string): string {
  return value.normalize("NFKC").toLocaleLowerCase().trim().replace(/\s+/g, " ");
}

export function renderCopyTemplate(template: string, song: PublicSong, settings: SiteSettings): string {
  return template
    .replaceAll("{title}", song.title)
    .replaceAll("{artist}", song.artist ?? "")
    .replaceAll("{singer}", settings.singer_name)
    .trim();
}

export async function copyText(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Fall through for browsers where Clipboard API is present but blocked.
    }
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  textarea.remove();
  if (!copied) throw new Error("clipboard unavailable");
}
